(function ($) {
    $(function () {
        var $slides = $('.image-gallery-slider .image-gallery-slide');
        $slides.each(function (i, el) {
            var $el = $(el);
            // read the img src from original img element
            var originSrc = $el.find('.image-gallery-slide-image').data('originsrc');
            $el.find('.image-gallery-slide-image').css('background-image', 'url(' + originSrc + ')');

        });

        $('.image-gallery-slider-big').slick({
            slidesToShow: 1,
            arrows: true
        });

        $('.image-gallery-slider-small')
            .on('init', function (event, slick) {
                $('.image-gallery-slider-small .slick-slide.slick-current .image-gallery-slide').addClass('active');
            })
            .slick({
                slidesToShow: 3,
                arrows: true
            });

        var button = document.getElementById("nextSlideBtn");
        var nextSlide = function nextSlide(slider) {
            $(slider).slick("slickNext");
        };
        if (button) {
            button.addEventListener("click", function () {
                return nextSlide(".image-gallery-slider-big");
            });
        }

        var buttonPrev = document.getElementById("prevSlideBtn");
        var prevSlide = function prevSlide(slider) {
            $(slider).slick("slickPrev");
        };
        if (buttonPrev) {
            buttonPrev.addEventListener("click", function () {
                return prevSlide(".image-gallery-slider-big");
            });
        }

        $('.image-gallery-slider-big').on('afterChange', function (event, slick, currentSlide) {
            $('.image-gallery-slider-small').slick('slickGoTo', currentSlide);
            var currrentNavSlideElem = '.image-gallery-slider-small .slick-slide[data-slick-index="' + currentSlide + '"] .image-gallery-slide';
            $('.image-gallery-slider-small .slick-slide .image-gallery-slide.active').removeClass('active');
            $(currrentNavSlideElem).addClass('active');
        });

        $('.image-gallery-slider-small').on('click', '.slick-slide', function (event) {
            event.preventDefault();
            var goToSingleSlide = $(this).data('slick-index');
            $('.image-gallery-slider-big').slick('slickGoTo', goToSingleSlide);
        });
    });
})(window.jQuery)
